import Vue from 'vue';
import i18next from 'i18next';
import HttpError from './HttpError';

export class ErrorHandler {
  handle(error) {
    if (error.code === 'ECONNABORTED') {
      Vue.notify({
        group: 'app',
        title: 'HTTP',
        type: 'error',
        text: i18next.t(error.code.toLowerCase())
      });
      throw error;
    }

    if (!error.response || !error.response.data && !error.response.data.error) {
      throw error;
    } else if (error.response && error.response.data && !error.response.data.error) {
      throw new HttpError(error.response.status, error.response.statusText);
    } else if (error.response.data.error) {
      const errorData = error.response.data.error;
      errorData.message = errorData.code ? i18next.t(errorData.code.toLowerCase()) : errorData.message;
      throw errorData;
    }
  }
}
